import React from 'react'
import FeatureIcon from 'components/icons/Feature'
import RouteAdminFeaturesGlobal from './features/global'
import RouteAdminFeaturesGroups from './features/groups'
import RouteAdminFeaturesUsers from './features/users'
import Sidebar from 'components/Sidebar'
import { Redirect, Route } from 'react-router-dom'
import { UserIcon, UsersIcon } from 'stylist'

const RouteAdminFeatures = ({ match: { path, url } }) => (
  <Sidebar.PageContainer>
    <Sidebar>
      <Sidebar.Nav>
        <Sidebar.NavItem
          to={`${url}/global`}
          renderIcon={() => <FeatureIcon size="1.25rem" />}
          label="All Features"
        />
        <Sidebar.NavItem
          to={`${url}/groups`}
          renderIcon={() => <UsersIcon size="1.25rem" />}
          label="Groups"
        />
        <Sidebar.NavItem
          to={`${url}/users`}
          renderIcon={() => <UserIcon size="1.25rem" />}
          label="Users"
        />
      </Sidebar.Nav>
    </Sidebar>
    <Route path={path} exact render={() => <Redirect to={`${url}/global`} />} />
    <Route path={`${path}/global`} component={RouteAdminFeaturesGlobal} />
    <Route path={`${path}/groups`} component={RouteAdminFeaturesGroups} />
    <Route path={`${path}/users`} component={RouteAdminFeaturesUsers} />
  </Sidebar.PageContainer>
)

export default RouteAdminFeatures



// WEBPACK FOOTER //
// ./src/routes/admin/features.js